// DO NOT EDIT -- generated from fs/services/webber/internal/highlight/highlight.proto

import * as playback from '../../../playback';
import * as protobuf from '../../../../../google/protobuf';

/**
 * SessionNotesPublic serves endpoints for FSTA related to the Note & Share feature on session replay. For historical
 * reasons, the terms Highlight and Note are used throughout the code. The original idea was that multiple "Notes" could
 * form a single "Highlight". In practice, this wasn't implemented so there is a 1-to-1 relationship where a Highlight
 * is always associated with a single Note, but there are two separate datastore entities. The terms Highlight and Note
 * are still used throughout the code, but we are working to deprecate them in favor of the term "Session Note".
 */
export namespace SessionNotesPublic {

  export const CreateShareLinkForNoteEndpoint = "/grpc/highlight.SessionNotesPublic/CreateShareLinkForNote";
  /** CreateShareLinkForNote creates and returns a ShareLink which can be used to view a Note in session replay. */
  export function CreateShareLinkForNote(sender: (req: CreateShareLinkForNoteRequest, endpoint: string) => Promise<CreateShareLinkForNoteResponse>, req: CreateShareLinkForNoteRequest): { promise: () => Promise<CreateShareLinkForNoteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateShareLinkForNoteEndpoint),
      endpoint: CreateShareLinkForNoteEndpoint
    };
  }

  export const CreateSessionNoteEndpoint = "/grpc/highlight.SessionNotesPublic/CreateSessionNote";
  /** CreateSessionNote creates a new session note and returns the created note. */
  export function CreateSessionNote(sender: (req: CreateSessionNoteRequest, endpoint: string) => Promise<CreateSessionNoteResponse>, req: CreateSessionNoteRequest): { promise: () => Promise<CreateSessionNoteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSessionNoteEndpoint),
      endpoint: CreateSessionNoteEndpoint
    };
  }

  export const ListSessionNotesEndpoint = "/grpc/highlight.SessionNotesPublic/ListSessionNotes";
  /** ListSessionNotes returns a specified number of Highlights, ordered by LastModified timestamp. */
  export function ListSessionNotes(sender: (req: ListSessionNotesRequest, endpoint: string) => Promise<ListSessionNotesResponse>, req: ListSessionNotesRequest): { promise: () => Promise<ListSessionNotesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListSessionNotesEndpoint),
      endpoint: ListSessionNotesEndpoint
    };
  }

  export const GetOrCreateHighlightShareLinkEndpoint = "/grpc/highlight.SessionNotesPublic/GetOrCreateHighlightShareLink";
  /**
   * GetOrCreateHighlightShareLink returns a share link for a given Highlight Id. If a share link does not already exist, a
   * share link will be created and saved.
   */
  export function GetOrCreateHighlightShareLink(sender: (req: GetOrCreateHighlightShareLinkRequest, endpoint: string) => Promise<GetOrCreateHighlightShareLinkResponse>, req: GetOrCreateHighlightShareLinkRequest): { promise: () => Promise<GetOrCreateHighlightShareLinkResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOrCreateHighlightShareLinkEndpoint),
      endpoint: GetOrCreateHighlightShareLinkEndpoint
    };
  }

  export const GetNotePreviewEndpoint = "/grpc/highlight.SessionNotesPublic/GetNotePreview";
  export function GetNotePreview(sender: (req: GetNotePreviewRequest, endpoint: string) => Promise<GetNotePreviewResponse>, req: GetNotePreviewRequest): { promise: () => Promise<GetNotePreviewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNotePreviewEndpoint),
      endpoint: GetNotePreviewEndpoint
    };
  }

  export const DeleteHighlightEndpoint = "/grpc/highlight.SessionNotesPublic/DeleteHighlight";
  export function DeleteHighlight(sender: (req: DeleteHighlightRequest, endpoint: string) => Promise<{}>, req: DeleteHighlightRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteHighlightEndpoint),
      endpoint: DeleteHighlightEndpoint
    };
  }

  export const DeleteNoteEndpoint = "/grpc/highlight.SessionNotesPublic/DeleteNote";
  export function DeleteNote(sender: (req: DeleteNoteRequest, endpoint: string) => Promise<{}>, req: DeleteNoteRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteNoteEndpoint),
      endpoint: DeleteNoteEndpoint
    };
  }
}

export interface CreateSessionNoteRequest {
  orgId: string;
  sessionNoteId: string;
  text: string;
  indvId: string;
  userId: string;
  sessionId: string;
  pageId: string;
  /** time of the start of the page being shared */
  pageStart: protobuf.timestamp | null;
  /** moment being shared, in millis relative to PageStart (the events offset) */
  when: protobuf.int64;
  /** absolute time of the session start */
  sessionStart: protobuf.timestamp | null;
  /** absolute time of moment being shared, should be set to PageStart + When */
  absTime: protobuf.timestamp | null;
  isClip: boolean;
  shareLink: string;
  devTools: playback.DevToolsMode;
  thumbnail: Thumbnail | null;
  sendTo: string[];
}

export interface CreateSessionNoteResponse {
  note: playback.Note | null;
  broadcastErrors: string[];
}

export interface Thumbnail {
  type: string;
  url: string;
  screenWidth: protobuf.int64;
  screenHeight: protobuf.int64;
  width: protobuf.int64;
  height: protobuf.int64;
  startTime: protobuf.timestamp | null;
  /** offset from StartTime in millis */
  playToTime: protobuf.int64;
  resources: { [key: string]: string };
  /** native mobile */
  buildId: string;
  rawEventUrls: string[];
}

export interface CreateShareLinkForNoteRequest {
  orgId: string;
  userId: string;
  sessionId: string;
  pageId: string;
  /** time of the start of the page being shared */
  pageStart: protobuf.timestamp | null;
  /** moment being shared, in millis relative to PageStart (the events offset) */
  when: protobuf.int64;
  /** absolute time of moment being shared, should be set to PageStart + When */
  absTime: protobuf.timestamp | null;
  /** Optional, if a Note ID is not provided, a note ID will be generated and returned in the response, but the note itself will not be created. */
  noteId: string;
  /** Optional. Append the /devtools/<mode> to path. */
  devToolsMode: playback.DevToolsMode;
}

export interface CreateShareLinkForNoteResponse {
  noteId: string;
  shareLink: string;
}

export interface ListSessionNotesRequest {
  orgId: string;
  /** Optional, user email address. When supplied, only Highlights created by this user will be returned. */
  creatorId: string;
  /** Optional, a datastore cursor that can be passed from a prior ListHighlightsResponse to continue the query from the given cursor */
  cursor: string;
  /** Required, number of Highlights to return in this request. Will return 0 Highlights if a number is not specified. */
  count: number;
}

export interface ListSessionNotesResponse {
  /** the email addresses of all users with a seat in this org */
  seats: string[];
  /** a list of Highlights ordered by LastModified timestamp, with most recent Highlights first */
  highlights: playback.Highlight[];
  /** a datastore cursor which can be passed in a subsequent ListHighlightRequest to resume a query for additional Highlights */
  cursor: string;
  /** indicates whether additional Highlights can be queried for */
  hasMore: boolean;
  /** integration-id -> service-name */
  activeIntegrations: { [key: string]: string };
}

export interface GetOrCreateHighlightShareLinkRequest {
  orgId: string;
  highlightId: string;
}

export interface GetOrCreateHighlightShareLinkResponse {
  shareLink: string;
}

export interface GetNotePreviewRequest {
  orgId: string;
  userId: string;
  sessionId: string;
  noteId: string;
}

export interface GetNotePreviewResponse {
  creator: string;
  created: protobuf.timestamp | null;
  text: string;
}

export interface DeleteHighlightRequest {
  orgId: string;
  highlightId: string;
}

export interface DeleteNoteRequest {
  orgId: string;
  userId: string;
  sessionId: string;
  noteId: string;
}
